const wasPartialApproval = (state, action) => {
  if (state === undefined) {
    return false;
  }
  switch (action.type) {
    case 'CREATE_RESULT_OF_PAY':
      if (action.payload?.transaction?.status === 'partial_approved') {
        return true;
      }
      return state.wasPartialApproval;
    // The partial approval belonged to the previous tab's transaction.
    case 'RESET_TAB_STATE':
      return false;
    default:
      return state.wasPartialApproval;
  }
};

export { wasPartialApproval };
